import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { ViewRiderNoteHistoryDialogComponent } from './view-rider-note-history-dialog.component';

@NgModule({
  imports: [CommonModule, MatDialogModule, MatDividerModule, MatButtonModule],
  exports: [ViewRiderNoteHistoryDialogComponent],
  declarations: [ViewRiderNoteHistoryDialogComponent]
})
export class ViewRiderNoteHistoryDialogModule {}
